import queryString from 'query-string';
import { useEffect, useState } from 'react';

type QueryParamsObj = {
  [key: string]: string | null | undefined;
};

const useQueryParameters = () => {
  const [parameters, setParameters] = useState<QueryParamsObj>({});

  useEffect(() => {
    const formattedQueryParamsObj: QueryParamsObj = {};

    const queryParamsObj = queryString.parse(window.location.search);
    Object.keys(queryParamsObj).forEach((key: string) => {
      const value = queryParamsObj[key];
      formattedQueryParamsObj[key] = Array.isArray(value)
        ? value.join()
        : value;
    });

    setParameters(formattedQueryParamsObj);
  }, []);

  return parameters;
};

export default useQueryParameters;
